import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-timeline',
  templateUrl: './icon-timeline.component.html',
  styles: []
})
export class IconTimelineComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
